/* albm-sticky-header.js — <albm-sticky-header> · OWNER: T0
   Ẩn khi cuộn xuống / hiện khi cuộn lên. Ngưỡng mặc định 136px, chống rung ±2px.
   Luôn set --albm-header-h trên :root để toolbar sticky của T3 dùng.
   Attribute: mode = "none" | "on-scroll-up" | "always" (mặc định on-scroll-up), threshold.
*/
class AlbmStickyHeader extends HTMLElement {
  connectedCallback() {
    this.mode = this.getAttribute('mode') || 'on-scroll-up';
    this.threshold = parseInt(this.getAttribute('threshold') || '136', 10);
    this.lastY = window.scrollY;
    this.hidden_ = false;

    this.measure();
    if ('ResizeObserver' in window) {
      this.ro = new ResizeObserver(() => this.measure());
      this.ro.observe(this);
    }

    if (this.mode === 'none') return;
    this.onScroll = this.onScroll.bind(this);
    window.addEventListener('scroll', this.onScroll, { passive: true });
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScroll);
    this.ro?.disconnect();
  }

  measure() {
    const h = Math.round(this.getBoundingClientRect().height);
    if (h > 0) document.documentElement.style.setProperty('--albm-header-h', `${h}px`);
  }

  onScroll() {
    const y = window.scrollY;
    const delta = y - this.lastY;
    if (Math.abs(delta) < 2) return; /* chống rung */

    if (this.mode === 'always' || y <= this.threshold) {
      this.setHidden(false);
    } else if (delta > 0) {
      this.setHidden(true);
    } else {
      this.setHidden(false);
    }

    this.classList.toggle('is-scrolled', y > this.threshold);
    this.lastY = y;
  }

  setHidden(value) {
    if (this.hidden_ === value) return;
    this.hidden_ = value;
    this.classList.toggle('is-hidden', value);
  }
}

if (!customElements.get('albm-sticky-header')) {
  customElements.define('albm-sticky-header', AlbmStickyHeader);
}
